export const formatPrice = (price: number, style = `currency`): string => {
	if (!price === undefined) return null

	return price?.toLocaleString(`ru-RU`, {
		// @ts-ignore
		style,
		currency: `RUB`,
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	})
}
